// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../Commons/properties/Resources.js";
import { GridPanelEditTemplate } from "../../templates.js";
import { PanelLocKeys } from "../UtilsClasses/FactoryConstants.js";
import { ContainerControl } from "./ContainerControl.js";
import { TerceraMenu } from "./TerceraMenu.js";

export let GridPanelEdit = ContainerControl.extend({
    el: '#gridPanelEditContainer',
    template: GridPanelEditTemplate,
    data: function ()
    {
        return {
            visible: false,
            width: 200,
            height: 223,

            menuItems: [],
            defaultRowsSelected: 1,
            defaultColumnsSelected: 1
        };
    },
    callBack: null
});

GridPanelEdit.prototype.getType = function () { return 'GridPanelEdit'; }

GridPanelEdit.prototype.oninit = function ()
{
    ContainerControl.prototype.oninit.apply(this);
    this.needResetLayout = this.needResetLayout.bind(this);
    this.newPanelTypeSelected = this.newPanelTypeSelected.bind(this);

    this.on('newGridSizeSelected', this.onNewGridSizeSelected);
};

GridPanelEdit.show = function (x, y, data, callBack)
{
    var gridPanelEdit = null;// App.gridPanelEdit;

    var loc = TerceraMenu.CorrectPopupLocation(new Rectangle(
        x,
        y,
        gridPanelEdit.get('width'),
        gridPanelEdit.get('height')));

    gridPanelEdit.callBack = callBack;

    gridPanelEdit.set({
        left: loc.newX,
        top: loc.newY,
        visible: true,

        menuItems: gridPanelEdit.createMenuItems(
            data.panelTypeArray,
            data.selectedPanelType,
            data.fixedSizePanelMode),

        defaultRowsSelected: data.rows,
        defaultColumnsSelected: data.columns
    });
};

GridPanelEdit.prototype.Hide = function ()
{
    this.callBack = null;
    this.set('visible', false);
};

GridPanelEdit.prototype.onNewGridSizeSelected = function (rows, columns)
{
    this.applyChanges({ rows: rows, columns: columns });
};

GridPanelEdit.prototype.newPanelTypeSelected = function (menuItem)
{
    this.applyChanges({ panelType: menuItem.tag });
};

GridPanelEdit.prototype.needResetLayout = function ()
{
    this.applyChanges({ resetLayout: true });
}

GridPanelEdit.prototype.applyChanges = function (data)
{
    if (this.callBack)
        this.callBack(data);

    this.Hide();
};

GridPanelEdit.prototype.createMenuItems = function (panelTypeArray, selectedPanelType, fixedSizePanelMode)
{
    var menuItems = [];

    var panelLocKeys = PanelLocKeys;

    for (var i = 0; i < panelTypeArray.length; i++)
    {
        var panelType = panelTypeArray[i];
        menuItems.push({
            text: Resources.getResource(panelLocKeys[panelType]),
            tag: panelType,
            event: this.newPanelTypeSelected,
            canCheck: true,
            checked: selectedPanelType === panelType,

            // http://tp.pfsoft.net/entity/60185
            // TODO. Refactor. TerceraMenu.prototype.private_onItemClick() calls contextMenuHandler.Hide() instead of this.Hide();
            closeOnClick: false
        });
    }

    menuItems.push({ separator: true });
    menuItems.push({
        text: Resources.getResource('panel.GridPanel.resetMI.Text'),
        tag: null,
        event: this.needResetLayout,
        enabled: !fixedSizePanelMode,

        // http://tp.pfsoft.net/entity/60185
        // TODO. Refactor. TerceraMenu.prototype.private_onItemClick() calls contextMenuHandler.Hide() instead of this.Hide();
        closeOnClick: false
    });

    return menuItems;
};